import DatePickerSidebar from "@/components/DatePickerSidebar";
import DatePickerRange from "@/components/DatePickerRange";
import DatePickerCalendar from "@/components/DatePickerCalendar";
import { EVENTS, generateMonthsBetweenYears, processDate, tryParse, isObjectEmpty } from "@/utils";
import moment from "moment";
import DatePickerLayout from "@/components/DatePickerLayout.vue";
import DatePickerCalendarMonth from "@/components/DatePickerCalendarMonth.vue";
import DatePickerSidebarSection from "@/components/DatePickerSidebarSection.vue";
import { getDatePickerRangeCompare, DATE_PICKER_RANGE_TITLES, DATE_PICKER_COMPARE_TITLES, getDatePickerUIObjectFromDateRange, DATE_PICKER_MODES, CUSTOM_COMPARE_FUNCTION, getDatePickerDayId } from "@/utils/datepicker";
import { toRaw, ref } from "vue";
import { generateDaysForMonthYear } from "../utils/datepicker";
import { localStorageSetItem } from "@/utils/storage";
import { DatePickerEngine } from "../utils/datepicker_engine";
export default {
  name: "DatePicker",
  components: {
    DatePickerSidebar,
    DatePickerRange,
    DatePickerCalendar,
    DatePickerCalendarMonth,
    DatePickerLayout,
    DatePickerSidebarSection
  },
  expose: ["setupDatePicker", "reset", "scrollTo", "state"],
  emits: ["cancel", "submit", "change", "afterCustomRefresh"],
  setup(props) {
    const getFilteredMonthList = () => {
      const today = moment();
      //console.log("Today", today.format("YYYY-MM-DD"));
      let months = generateMonthsBetweenYears(today.year() - 3, today.year() + 1);
      //console.log("Months", months);

      months = months.filter(({
        date
      }) => {
        return date.isSameOrBefore(today);
      });

      // We insert into `datesMap` using `MONTH_YEAR` as key and `generateDaysForMonthYear(month, year, this.weekType)` as value
      return months;
    };
    const filteredMonthList = ref(getFilteredMonthList());
    const filteredDatesMap = ref(new Map(filteredMonthList.value.map(({
      month,
      year
    }) => {
      return [`${month}_${year}`, generateDaysForMonthYear(month, year, props.weekType)];
    })));

    //console.log("filtered", filteredMonthList, filteredDatesMap)
    return {
      filteredMonthList,
      filteredDatesMap
    };
  },
  mounted() {
    //console.log("filtered", this.filteredMonthList);
    window.$bus.on(EVENTS.RESET_DATE_PICKER, this.reset);
    window.$bus.on(EVENTS.SETUP_DATE_PICKER, this.setupDatePicker);
    window.$bus.on(EVENTS.SWITCH_COMPARE_TO_PREV_PERIOD, this.switchToPreviousPeriodCompare);
    window.$bus.on(EVENTS.SWITCH_COMPARE_TO_SAME_PERIOD_LY, this.switchToLastYearCompare);
    // this.datesMap =
    // this.handleRangeClick()
  },
  unmounted() {
    window.$bus.off(EVENTS.SETUP_DATE_PICKER, this.setupDatePicker);
    window.$bus.off(EVENTS.RESET_DATE_PICKER, this.reset);
    window.$bus.off(EVENTS.SWITCH_COMPARE_TO_PREV_PERIOD, this.switchToPreviousPeriodCompare);
    window.$bus.off(EVENTS.SWITCH_COMPARE_TO_SAME_PERIOD_LY, this.switchToLastYearCompare);
  },
  props: {
    date: {
      type: Object
    },
    weekType: {
      type: String
    },
    selectedPeriod: {
      type: String
    }
  },
  data() {
    const engine = new DatePickerEngine({
      weekType: this.weekType,
      selectedPeriod: this.selectedPeriod,
      rangeType: this._range || DATE_PICKER_RANGE_TITLES.CURRENT_WEEK,
      compareType: this._compare || DATE_PICKER_COMPARE_TITLES.PRECEDING_PERIOD
    });
    return {
      _range: DATE_PICKER_RANGE_TITLES.CURRENT_WEEK,
      _compare: DATE_PICKER_COMPARE_TITLES.PRECEDING_PERIOD,
      periodOptions: [{
        key: DATE_PICKER_RANGE_TITLES.YESTERDAY,
        name: DATE_PICKER_RANGE_TITLES.YESTERDAY
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_7_DAYS,
        name: DATE_PICKER_RANGE_TITLES.LAST_7_DAYS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_28_DAYS,
        name: DATE_PICKER_RANGE_TITLES.LAST_28_DAYS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_WEEK,
        name: DATE_PICKER_RANGE_TITLES.LAST_WEEK
      }, {
        key: DATE_PICKER_RANGE_TITLES.CURRENT_WEEK,
        name: DATE_PICKER_RANGE_TITLES.CURRENT_WEEK
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_MONTH,
        name: DATE_PICKER_RANGE_TITLES.LAST_MONTH
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_QUARTER,
        name: DATE_PICKER_RANGE_TITLES.LAST_QUARTER
      }, {
        key: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH,
        name: DATE_PICKER_RANGE_TITLES.CURRENT_MONTH
      }, {
        key: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER,
        name: DATE_PICKER_RANGE_TITLES.CURRENT_QUARTER
      }, {
        key: DATE_PICKER_RANGE_TITLES.CURRENT_YEAR,
        name: DATE_PICKER_RANGE_TITLES.CURRENT_YEAR
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_90_DAYS,
        name: DATE_PICKER_RANGE_TITLES.LAST_90_DAYS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_365_DAYS,
        name: DATE_PICKER_RANGE_TITLES.LAST_365_DAYS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_12_MONTHS,
        name: DATE_PICKER_RANGE_TITLES.LAST_12_MONTHS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_12_WEEKS,
        name: DATE_PICKER_RANGE_TITLES.LAST_12_WEEKS
      }, {
        key: DATE_PICKER_RANGE_TITLES.LAST_YEAR,
        name: DATE_PICKER_RANGE_TITLES.LAST_YEAR
      }, {
        key: DATE_PICKER_RANGE_TITLES.CUSTOM,
        name: DATE_PICKER_RANGE_TITLES.CUSTOM
      }],
      compareOptions: [{
        key: DATE_PICKER_COMPARE_TITLES.CUSTOM,
        name: DATE_PICKER_COMPARE_TITLES.CUSTOM
      }, {
        key: DATE_PICKER_COMPARE_TITLES.PRECEDING_PERIOD,
        name: DATE_PICKER_COMPARE_TITLES.PRECEDING_PERIOD
      }, {
        key: DATE_PICKER_COMPARE_TITLES.SAME_PERIOD_LY,
        name: DATE_PICKER_COMPARE_TITLES.SAME_PERIOD_LY
      }],
      DATE_PICKER_MODE: DATE_PICKER_MODES.READ_ONLY_MODE,
      _state: engine.toJSON(),
      engine
    };
  },
  computed: {
    currentDate() {
      return this.state;
    },
    state() {
      return this.engine.toJSON();
    },
    range: {
      get() {
        return this.engine.rangeType;
      },
      set(val) {
        this.engine.selectRangeType(val);
        this._state = this.engine.toJSON();

        // Scroll to end of range start month for better visibility
        if (this._state.range.start) {
          const scrollDate = moment(this._state.range.start).endOf("month");
          this.scrollTo(getDatePickerDayId(scrollDate.format("YYYY-MM-DD"), "month-date"));
        }
      }
    },
    compare: {
      get() {
        return this.engine.compareType;
      },
      set(val) {
        this.engine.selectCompareType(val);
        this._state = this.engine.toJSON();
      }
    },
    rangePosition: {
      get() {
        return this.engine.getRangePosition();
      },
      set(val) {
        this.engine.setRangePosition(val);
        this._state = this.engine.toJSON();
      }
    },
    comparePosition: {
      get() {
        return this.engine.getComparePosition();
      },
      set(val) {
        this.engine.setComparePosition(val);
        this._state = this.engine.toJSON();
      }
    },
    rangeOptions() {
      return [{
        text: this.rangeFormatted(this.state.range.start, "start"),
        value: "start"
      }, {
        text: this.rangeFormatted(this.state.range.end, "end"),
        value: "end"
      }];
    },
    compareRangeOptions() {
      return [{
        text: this.compareFormatted(this.state.compare.start, "start"),
        value: "start"
      }, {
        text: this.compareFormatted(this.state.compare.end, "end"),
        value: "end"
      }];
    }
  },
  watch: {
    compare: {
      handler(newVal, oldVal) {
        if (oldVal === DATE_PICKER_COMPARE_TITLES.CUSTOM && newVal !== DATE_PICKER_COMPARE_TITLES.CUSTOM) {
          this.$emit("afterCustomRefresh");
        }
      },
      immediate: true
    }
  },
  methods: {
    setupDatePicker(rangeTitle, compareTitle, state) {
      this.engine.reset({
        rangeTitle,
        compareTitle,
        range: state.range,
        compare: state.compare
      });
      this._state = this.engine.toJSON();
      this._range = this.engine.rangeType;
      this._compare = this.engine.compareType;
    },
    onCancel() {
      this.$emit("cancel");
    },
    onOk() {
      let date = {
        rangeTitle: this.range,
        compareTitle: this.compare,
        ...this.state
      };
      this.saveDate(date);
      console.log('onOk', date);
      this.$emit("submit", getDatePickerUIObjectFromDateRange(date));
    },
    rangeFormatted(date, type) {
      const output = processDate(date, "DD MMM YYYY");
      if (!output) {
        if (this.range === DATE_PICKER_RANGE_TITLES.CUSTOM) {
          return `Select ${type} date`;
        }
        return "-";
      }
      return output;
    },
    compareFormatted(date, type) {
      const output = processDate(date, "DD MMM YYYY");
      if (!output) {
        if (this.compare === DATE_PICKER_COMPARE_TITLES.CUSTOM) {
          return `Select ${type} date`;
        }
        return "-";
      }
      return output;
    },
    onDayDateClick(date) {
      // Delegate to the engine
      this.engine.clickDate(date);

      // Update reactive Vue state
      this._state = this.engine.toJSON();
    },
    reset(date) {
      this.engine.reset(date);
      this._state = this.engine.toJSON();
      this._range = this.engine.rangeType;
      this._compare = this.engine.compareType;
      this.saveDate(date);
    },
    scrollTo(id) {
      this.$refs.calendar.scrollTo(id);
    },
    saveDate(date) {
      let current_workspace = tryParse(localStorage.getItem("current_workspace"));
      if (!isObjectEmpty(current_workspace)) {
        localStorageSetItem(current_workspace.workspace_id + "date_picker", JSON.stringify(date));
      }
    },
    switchToPreviousPeriodCompare() {
      this.engine.selectCompareType(DATE_PICKER_COMPARE_TITLES.PRECEDING_PERIOD);
    },
    switchToLastYearCompare() {
      this.engine.selectCompareType(DATE_PICKER_COMPARE_TITLES.SAME_PERIOD_LY);
    }
  }
};